module.exports = __webpack_public_path__ + "chevron.png?dc904f3cb426fe749240bd84781f01c9";